import React from 'react'

const Skeleton = (props) => {
            const {type}=props;
  return (
    <div  className={`skeleton ${type}`}>
      
    </div>
  )
}

export default Skeleton;
